import { render, staticRenderFns } from "./Note.vue?vue&type=template&id=37c67a5d&scoped=true"
import script from "./Note.vue?vue&type=script&lang=js"
export * from "./Note.vue?vue&type=script&lang=js"
import style0 from "./Note.vue?vue&type=style&index=0&id=37c67a5d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c67a5d",
  null
  
)

export default component.exports